<template>
    <div
        class="h-screen max-w-xl mx-auto p-4 flex flex-col items-center justify-center space-y-8"
    >
        <div>
            <AppLogo :appName="appSharedData.appName" />
        </div>
        <div class="space-y-2 text-center">
            <div class="text-3xl font-semibold text-gray-900">
                {{ title }}
            </div>
            <div
                v-if="subtitle"
                class="text-gray-700"
            >
                {{ subtitle }}
            </div>
        </div>
        <div>
            <Button
                as="a"
                :href="buttonLink"
                iconName="angle-left"
                color="light"
                size="small"
            >
                {{ buttonText }}
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import Button from '@/Shared/Component/Button.vue'
    import AppSharedData from '@/Shared/Entity/AppSharedData'

    interface ErrorPageProps {
        appSharedDataData: any
        title: string
        subtitle: string | null
        buttonText: string
        buttonLink: string
    }

    const props = defineProps<ErrorPageProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
</script>
